import 'unpoly';
import 'unpoly/unpoly-bootstrap5';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import '@ngenic/compilers/controller.compiler';
import '@ngenic/compilers/form-validation.compiler';
import '@ngenic/compilers/cookie-consent.compiler';
import '@ngenic/compilers/billingperiod-switch.compiler';
import '@ngenic/compilers/main-menu-dropdown.compiler';
import '@ngenic/compilers/feature-tooltip.compiler';
import '@ngenic/compilers/analytics-ecommerce.compiler';

import '@ngenic/previews/input-spinner.preview';
import '@ngenic/previews/content-spinner.preview';

import '@ngenic/macros/site-snackbar.macro';
import '@ngenic/macros/confirm-dialog.macro';

const getModules = (context: __WebpackModuleApi.RequireContext) => context.keys().map(context);
const pagesContext = require.context('../../Pages', true, /\.ts$/);
const areasContext = require.context('../../Areas', true, /\.ts$/);
getModules(pagesContext);
getModules(areasContext);

up.log.config.enabled = true;

up.network.config.progressBar = false;
up.protocol.config.csrfToken = (): string => {
    var inputNode = up.element.get('input[name="__RequestVerificationToken"]');
    if (inputNode)
        return inputNode.value;

    return null;
}
up.fragment.config.autoHistoryTargets = ['main', '* > form'];
up.fragment.config.skipResponse = ({ response, expiredResponse }) => {
    const shouldSkip = !response.text || response.text === expiredResponse?.text;
    if (shouldSkip)
        up.emit('up:render:skip', {});
    return shouldSkip;
};

up.link.config.followSelectors.push(
    'a[href].btn',
    'nav[aria-label="breadcrumb"] a'
);

up.on('up:request:load', (event) => {
    const { request } = event;

    request.headers['Accept'] = 'text/html';
});